export default "__VITE_ASSET__CAa7_mGQ__"